import React from 'react';
import IconCardsSection from 'components/Sections/IconCardsSection';
import CallToActionCards from 'components/Sections/CallToActionCards';

const ContentfulCardsBlock = (props) => {
  const {
    anchorId,
    cols,
    cardType,
    title,
    subTitle,
    subheading,
    cards,
    slug,
    id,
    logos,
    cta,
    subDescription,
    bgColor,
  } = props || {};

  if (cardType === 'Icon') {
    return (
      <IconCardsSection
        title={title}
        cards={cards}
        cols={cols}
        className={slug}
        key={id}
        id={anchorId}
      />
    );
  }
  if (['Image', 'Video'].includes(cardType)) {
    return (
      <CallToActionCards
        {...props}
        cta={cta}
        backgroundColor={bgColor}
        cardInfo={cards}
        subDescription={subDescription}
        subLogos={logos}
        cols={cols}
        key={id}
        id={anchorId}
      />
    );
  }

  return null;
};
export default ContentfulCardsBlock;
